import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { ISoftwareSettingsRepository } from "@domain/repositories";
import { PagedSoftwareSettingsMetadataList, SettingsTypeEnumSchema } from "@domain/schemas/BI";

@injectable()
export class ListSoftwareSettingsService {
  @inject(TYPES.ISoftwareSettingsRepository)
  private _softwareSettingsRepository!: ISoftwareSettingsRepository;

  async getSettingsListAsync(settingsType: SettingsTypeEnumSchema): Promise<PagedSoftwareSettingsMetadataList> {
    return this._softwareSettingsRepository.GetListAsync(settingsType);
  }
}
